/**
 * PublicFooter.tsx
 * Site footer shared across all public-facing pages (About, Terms, Privacy).
 * Uses the ab-site-footer CSS class defined in AboutPage.css.
 */

import { Link } from 'react-router-dom';

export function PublicFooter() {
  return (
    <footer className="ab-site-footer">
      <Link to="/terms">Terms &amp; Conditions</Link>
      {' · '}
      <Link to="/privacy">Privacy Policy</Link>
      {' · '}
      <a href="mailto:hello@joinedupdata.io">hello@joinedupdata.io</a>
      {' · '}
      &copy; {new Date().getFullYear()} Joined-up Data Ltd
    </footer>
  );
}
